<template>
  <div>
    <Breadcrumb :breadcrumbList="breadcrumbList" />

    <div class="content-header px-0">
      <h1 class="title-I">Adicionar coletor</h1>
    </div>

    <div class="col-12 col-sm-12 p-0 col-md-12">
      <div class="card-body">
        <div class="pt-4 pr-4 pb-2 pl-4 bg-white rounded">
          <div class="row mb-2">
            <div class="col-12">
              <div class="card direct-chat direct-chat-primary employee">
                <div class="card-body custom-card overflow-visible">
                  <ul class="nav nav-tabs bg-main">
                    <li class="nav-item">
                      <a
                        id="addGateway-tab"
                        class="nav-link first"
                        v-bind:class="{
                          active: true,
                        }"
                        href="#"
                        aria-current="addGateway"
                        tabindex="-1"
                        >Adicionar coletor</a
                      >
                    </li>
                  </ul>
                  <div class="p-4 bg-white rounded">
                    <div class="tab-content">
                      <div
                        class="tab-pane fade"
                        v-bind:class="{
                          show: true,
                          active: true,
                        }"
                      >
                        <div class="row">
                          <div class="card-body">
                            <div class="p-4 bg-white rounded">
                              <form @submit="saveGateway" novalidate="true">
                                <div class="col-12">
                                  <div class="row">
                                    <TwInput
                                      label="Nome do coletor"
                                      required="false"
                                    >
                                      <input
                                        id="gatewayName"
                                        v-model="gateway.gateway_name"
                                        type="text"
                                        maxlength="40"
                                        class="form-control"
                                        placeholder="Nome do coletor"
                                      />
                                    </TwInput>
                                    <TwInput
                                      label="Identificador"
                                      required="false"
                                    >
                                      <i
                                        title="Formato de endereço MAC, separadores opcionais"
                                        class="fas fa-question-circle"
                                        style="margin-left: 5px"
                                      >
                                      </i>
                                      <input
                                        id="macGateway"
                                        required
                                        v-model="gateway.mac_address"
                                        v-mask="'NN:NN:NN:NN:NN:NN'"
                                        type="text"
                                        class="form-control"
                                        placeholder="Identificador do coletor"
                                      />
                                    </TwInput>

                                    <TwInput label="Tipo" required="false">
                                      <select
                                        required
                                        class="form-control"
                                        v-model="gateway.gateway_type"
                                        id="gatewayType"
                                      >
                                        <option
                                          v-for="(gateway_type, index) in types"
                                          v-bind:value="gateway_type.name"
                                          v-bind:key="index"
                                        >
                                          {{ gateway_type.name }}
                                        </option>
                                      </select>
                                    </TwInput>
                                    <TwInput label="Número de série" required="true">
                                      <input
                                        id="serialnumberGateway"
                                        v-model="gateway.serial_number"
                                        type="text"
                                        maxlength="30"
                                        class="form-control"
                                        placeholder="Número serial do coletor"
                                      />
                                    </TwInput>
                                  </div>
                                  <div class="row">
                                    <TwInput label="Modelo" required="false">
                                      <select
                                        id="gtw-add-model-select"
                                        class="form-control"
                                        v-model="gateway.gateway_model"
                                      >
                                        <option
                                          v-for="(model, index) in models"
                                          v-bind:value="model.name"
                                          v-bind:key="index"
                                          :id="'gtw-add-model-' + model.name + '-' + index"
                                        >
                                          {{ model.name }}
                                        </option>
                                      </select>
                                    </TwInput>
                                  </div>
                                  <!-- AUTOPROVISIONAMENTO -->
                                </div>
                                <div class="row p-1">
                                  <button
                                    id="saveNewGateway"
                                    class="btn btn-primary px-5"
                                    :disabled="load"
                                  >
                                    <i
                                      v-if="load"
                                      class="fas fa-sync-alt fa-spin"
                                    ></i>
                                    Salvar
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "../../components/Breadcrumb.vue";
import TwInput from "@/components/TwInput.vue";
export default {
  name: "AddGateway",
  data: function () {
    return {
      breadcrumbList: [],
      gateway: {
        gateway_model: "DEFAULT",
        gateway_name: "",
        gateway_type: "MOBILE",
        mac_address: "",
        serial_number: "",
      }
    };
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("gateway/getModels");
    this.$store.dispatch("gateway/getTypes");
  },
  watch: {
    $route() {
      this.updateList();
    },
  },
  methods: {
    checkForEmpty(strings, msgs){
      for (let i = 0; i < strings.length; i++) {
        if (strings[i].trim() == "") {
          window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: msgs[i] }
        );
          return false;
        } 
      }
      return true;
    },
    isGatewayValid(gateway) {
      let strings = [gateway.gateway_model, gateway.gateway_name, gateway.gateway_type, gateway.mac_address, gateway.serial_number];
      let msgs = ["Modelo", "Nome", "Tipo", "Identificador", "Número de série"];

      if (!this.checkForEmpty(strings, msgs)) {
        return false;
      }

      let mac_regex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
      if (gateway.mac_address.length != 17 || !mac_regex.test(gateway.mac_address)) {
        window.frontMsg(
          "FRNT_INVALID_FIELD_WARNING",
          { field: "Identificador", extra: "Utilize formato MAC" }
        );
        return false;
      }

      let mac_address = gateway.mac_address.replace(/:|-/g, "");
      let checkMac = (obj) => obj.mac_address === mac_address;

      if (this.gateways.some(checkMac)) {
          window.frontMsg(
            "FRNT_IN_USE_WARNING",
                        { field: "Identificador" }
          );
        return false;
      }
      
      return true;
    },
    saveGateway() {
      event.preventDefault();
      if (!this.isGatewayValid(this.gateway)) {
        return;
      } else {
        let mac_address = this.gateway.mac_address
          .replace(/:|-/g, "")
          .toLowerCase();

        this.$store.dispatch("gateway/saveGateway", {
            ...this.gateway,
            mac_address: mac_address,
        });
      }
    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    },
  },
  components: {
    Breadcrumb,
    TwInput,
  },
  computed: {
    load() {
      return this.$store.getters["load"];
    },
    models() {
      return this.$store.getters["gateway/models"];
    },
    types() {
      return this.$store.getters["gateway/types"];
    },
    gateways() {
      return this.$store.getters["gateway/gateways"];
    },
  },
};
</script>
<style>
.margin-left-zero {
  margin-left: 0;
}
</style>